/* tslint:disable:max-line-length jsx-self-close */
export const GooglePlayBadge: React.FunctionComponent<{
    height: string
    width: string
}> = (props) => (
    <svg
        width={props.width}
        height={props.height}
        viewBox="0 0 135 40"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M130,40 L5,40 C2.2,40 0,37.8 0,35 L0,5 C0,2.2 2.2,0 5,0 L130,0 C132.8,0 135,2.2 135,5 L135,35 C135,37.7 132.8,40 130,40 Z"
            id="Shape"
            fill="#000000"></path>
        <path
            d="M130,0.8 C132.3,0.8 134.2,2.7 134.2,5 L134.2,35 C134.2,37.3 132.3,39.2 130,39.2 L5,39.2 C2.7,39.2 0.8,37.3 0.8,35 L0.8,5 C0.8,2.7 2.7,0.8 5,0.8 L130,0.8 L130,0.8 Z M130,0 L5,0 C2.2,0 0,2.2 0,5 L0,35 C0,37.8 2.2,40 5,40 L130,40 C132.8,40 135,37.8 135,35 L135,5 C135,2.3 132.8,0 130,0 L130,0 Z"
            id="Shape"
            fill="#A6A6A6"></path>
        <g
            transform="translate(41.000000, 6.000000)"
            id="Shape"
            stroke="#FFFFFF"
            strokeWidth="0.2"
            fill="#FFFFFF">
            <path d="M6.4,4.2 C6.4,5 6.2,5.7 5.7,6.2 C5.1,6.8 4.4,7.1 3.5,7.1 C2.6,7.1 1.9,6.8 1.3,6.2 C0.7,5.6 0.4,4.9 0.4,4 C0.4,3.1 0.7,2.4 1.3,1.8 C1.9,1.2 2.6,0.9 3.5,0.9 C3.9,0.9 4.3,1 4.7,1.2 C5.1,1.4 5.4,1.6 5.6,1.9 L5.1,2.4 C4.7,1.9 4.2,1.7 3.5,1.7 C2.9,1.7 2.3,1.9 1.9,2.4 C1.4,2.8 1.2,3.4 1.2,4.1 C1.2,4.8 1.4,5.4 1.9,5.8 C2.4,6.2 2.9,6.5 3.5,6.5 C4.2,6.5 4.7,6.3 5.2,5.8 C5.5,5.5 5.7,5.1 5.7,4.6 L3.5,4.6 L3.5,3.9 L6.4,3.9 C6.4,3.9 6.4,4.1 6.4,4.2 Z"></path>
            <polygon points="11 1.7 8.3 1.7 8.3 3.6 10.8 3.6 10.8 4.3 8.3 4.3 8.3 6.2 11 6.2 11 7 7.5 7 7.5 1 11 1"></polygon>
            <polygon points="14.3 7 13.5 7 13.5 1.7 11.8 1.7 11.8 1 16 1 16 1.7 14.3 1.7"></polygon>
            <polygon points="18.9 7 18.9 1 19.7 1 19.7 7"></polygon>
            <polygon points="23.1 7 22.3 7 22.3 1.7 20.6 1.7 20.6 1 24.7 1 24.7 1.7 23 1.7 23 7"></polygon>
            <path d="M32.6,6.2 C32,6.8 31.3,7.1 30.4,7.1 C29.5,7.1 28.8,6.8 28.2,6.2 C27.6,5.6 27.3,4.9 27.3,4 C27.3,3.1 27.6,2.4 28.2,1.8 C28.8,1.2 29.5,0.9 30.4,0.9 C31.3,0.9 32,1.2 32.6,1.8 C33.2,2.4 33.5,3.1 33.5,4 C33.5,4.9 33.2,5.6 32.6,6.2 Z M28.8,5.7 C29.2,6.1 29.8,6.4 30.4,6.4 C31,6.4 31.6,6.2 32,5.7 C32.4,5.3 32.7,4.7 32.7,4 C32.7,3.3 32.5,2.7 32,2.3 C31.6,1.9 31,1.6 30.4,1.6 C29.8,1.6 29.2,1.8 28.8,2.3 C28.4,2.7 28.1,3.3 28.1,4 C28.1,4.7 28.3,5.3 28.8,5.7 Z"></path>
            <polygon points="34.6 7 34.6 1 35.5 1 38.4 5.7 38.4 5.7 38.4 4.5 38.4 1 39.2 1 39.2 7 38.4 7 35.3 2.1 35.3 2.1 35.3 3.3 35.3 7"></polygon>
        </g>
        <path
            d="M68.1,21.8 C65.7,21.8 63.8,23.6 63.8,26.1 C63.8,28.5 65.7,30.4 68.1,30.4 C70.5,30.4 72.4,28.6 72.4,26.1 C72.4,23.5 70.5,21.8 68.1,21.8 Z M68.1,28.6 C66.8,28.6 65.7,27.5 65.7,26 C65.7,24.5 66.8,23.4 68.1,23.4 C69.4,23.4 70.5,24.4 70.5,26 C70.5,27.5 69.4,28.6 68.1,28.6 Z M58.8,21.8 C56.4,21.8 54.5,23.6 54.5,26.1 C54.5,28.5 56.4,30.4 58.8,30.4 C61.2,30.4 63.1,28.6 63.1,26.1 C63.1,23.5 61.2,21.8 58.8,21.8 Z M58.8,28.6 C57.5,28.6 56.4,27.5 56.4,26 C56.4,24.5 57.5,23.4 58.8,23.4 C60.1,23.4 61.2,24.4 61.2,26 C61.2,27.5 60.1,28.6 58.8,28.6 Z M47.7,23.1 L47.7,24.9 L52,24.9 C51.9,25.9 51.5,26.7 51,27.2 C50.4,27.8 49.4,28.5 47.7,28.5 C45,28.5 43,26.4 43,23.7 C43,21 45.1,18.9 47.7,18.9 C49.1,18.9 50.2,19.5 51,20.2 L52.3,18.9 C51.2,17.9 49.8,17.1 47.8,17.1 C44.2,17.1 41.1,20.1 41.1,23.7 C41.1,27.3 44.2,30.3 47.8,30.3 C49.8,30.3 51.2,29.7 52.4,28.4 C53.6,27.2 54,25.5 54,24.2 C54,23.8 54,23.4 53.9,23.1 L47.7,23.1 L47.7,23.1 Z M93.1,24.5 C92.7,23.5 91.7,21.8 89.5,21.8 C87.3,21.8 85.5,23.5 85.5,26.1 C85.5,28.5 87.3,30.4 89.7,30.4 C91.6,30.4 92.8,29.2 93.2,28.5 L91.8,27.5 C91.3,28.2 90.7,28.7 89.7,28.7 C88.7,28.7 88.1,28.3 87.6,27.4 L93.3,25 L93.1,24.5 Z M87.3,25.9 C87.3,24.3 88.6,23.4 89.5,23.4 C90.2,23.4 90.9,23.8 91.1,24.3 L87.3,25.9 Z M82.6,30 L84.5,30 L84.5,17.5 L82.6,17.5 L82.6,30 Z M79.6,22.7 L79.6,22.7 C79.1,22.2 78.3,21.7 77.3,21.7 C75.2,21.7 73.2,23.6 73.2,26 C73.2,28.4 75.1,30.2 77.3,30.2 C78.3,30.2 79.1,29.7 79.5,29.2 L79.6,29.2 L79.6,29.8 C79.6,31.4 78.7,32.3 77.3,32.3 C76.2,32.3 75.4,31.5 75.2,30.8 L73.6,31.5 C74.1,32.6 75.3,34 77.4,34 C79.6,34 81.4,32.7 81.4,29.6 L81.4,22 L79.6,22 L79.6,22.7 L79.6,22.7 Z M77.4,28.6 C76.1,28.6 75,27.5 75,26 C75,24.5 76.1,23.4 77.4,23.4 C78.7,23.4 79.7,24.5 79.7,26 C79.7,27.5 78.7,28.6 77.4,28.6 Z M101.8,17.5 L97.3,17.5 L97.3,30 L99.2,30 L99.2,25.3 L101.8,25.3 C103.9,25.3 105.9,23.8 105.9,21.4 C105.9,19 103.9,17.5 101.8,17.5 Z M101.9,23.5 L99.2,23.5 L99.2,19.2 L101.9,19.2 C103.3,19.2 104.1,20.4 104.1,21.3 C104,22.4 103.2,23.5 101.9,23.5 Z M113.4,21.7 C112,21.7 110.6,22.3 110.1,23.6 L111.8,24.3 C112.2,23.6 112.8,23.4 113.5,23.4 C114.5,23.4 115.4,24 115.5,25 L115.5,25.1 C115.2,24.9 114.4,24.6 113.6,24.6 C111.8,24.6 110,25.6 110,27.4 C110,29.1 111.5,30.2 113.1,30.2 C114.4,30.2 115,29.6 115.5,29 L115.6,29 L115.6,30 L117.4,30 L117.4,25.2 C117.2,23 115.5,21.7 113.4,21.7 Z M113.2,28.6 C112.6,28.6 111.7,28.3 111.7,27.5 C111.7,26.5 112.8,26.2 113.7,26.2 C114.5,26.2 114.9,26.4 115.4,26.6 C115.2,27.8 114.2,28.6 113.2,28.6 Z M123.7,22 L121.6,27.4 L121.5,27.4 L119.3,22 L117.3,22 L120.6,29.6 L118.7,33.8 L120.6,33.8 L125.7,22 L123.7,22 Z M106.9,30 L108.8,30 L108.8,17.5 L106.9,17.5 L106.9,30 Z"
            id="Shape"
            fill="#FFFFFF"></path>

        <g transform="translate(9.000000, 7.000000)" id="Shape">
            <linearGradient
                id="SVGID_1_"
                gradientUnits="userSpaceOnUse"
                x1="31.7997"
                y1="183.2903"
                x2="15.0173"
                y2="166.5079"
                gradientTransform="matrix(1 0 0 -1 0 202)">
                <stop offset="0%" stopColor="#00A0FF" />
                <stop offset="0.6574450%" stopColor="#00A1FF" />
                <stop offset="26.01%" stopColor="#00BEFF" />
                <stop offset="51.22%" stopColor="#00D2FF" />
                <stop offset="76.04%" stopColor="#00DFFF" />
                <stop offset="100%" stopColor="#00E3FF" />
            </linearGradient>
            <path
                fill="url(#SVGID_1_)"
                d="M1.4,0.5 C1.1,0.8 0.9,1.3 0.9,1.9 L0.9,24 C0.9,24.6 1.1,25.1 1.4,25.4 L1.5,25.5 L13.9,13.1 L13.9,13 L13.9,12.9 L1.4,0.5 L1.4,0.5 Z"
            />

            <linearGradient
                id="SVGID_2_"
                gradientUnits="userSpaceOnUse"
                x1="43.8344"
                y1="171.9986"
                x2="19.6375"
                y2="171.9986"
                gradientTransform="matrix(1 0 0 -1 0 202)">
                <stop offset="0%" stopColor="#FFE000" />
                <stop offset="40.87%" stopColor="#FFBD00" />
                <stop offset="77.54%" stopColor="#FFA500" />
                <stop offset="100%" stopColor="#FF9C00" />
            </linearGradient>
            <path
                fill="url(#SVGID_2_)"
                d="M18,17.3 L13.9,13.2 L13.9,13 L13.9,12.9 L18,8.8 L18.1,8.9 L23,11.7 C24.4,12.5 24.4,13.8 23,14.6 L18,17.3 L18,17.3 Z"
            />

            <linearGradient
                id="SVGID_3_"
                gradientUnits="userSpaceOnUse"
                x1="34.827"
                y1="169.7039"
                x2="12.0687"
                y2="146.9456"
                gradientTransform="matrix(1 0 0 -1 0 202)">
                <stop offset="0%" stopColor="#FF3A44" />
                <stop offset="100%" stopColor="#C31162" />
            </linearGradient>
            <path
                fill="url(#SVGID_3_)"
                d="M18.1,17.2 L13.9,13 L1.4,25.5 C1.9,26 2.6,26 3.5,25.6 L18.1,17.2"
            />

            <linearGradient
                id="SVGID_4_"
                gradientUnits="userSpaceOnUse"
                x1="17.2973"
                y1="191.8238"
                x2="27.4599"
                y2="181.6613"
                gradientTransform="matrix(1 0 0 -1 0 202)">
                <stop offset="0%" stopColor="#32A071" />
                <stop offset="6.85%" stopColor="#2DA771" />
                <stop offset="47.62%" stopColor="#15CF74" />
                <stop offset="80.09%" stopColor="#06E775" />
                <stop offset="100%" stopColor="#00F076" />
            </linearGradient>
            <path
                fill="url(#SVGID_4_)"
                d="M18.1,8.8 L3.5,0.5 C2.6,-1.77635684e-15 1.9,0.1 1.4,0.6 L13.9,13 L18.1,8.8 Z"
            />

            <g transform="translate(1.000000, 17.000000)" fill="#000000">
                <path
                    d="M17,0.1 L2.5,8.3 C1.7,8.8 1,8.7 0.5,8.3 L0.5,8.3 L0.4,8.4 L0.4,8.4 L0.5,8.5 L0.5,8.5 C1,8.9 1.7,9 2.5,8.5 L17,0.1 L17,0.1 Z"
                    opacity="0.2"></path>
                <path
                    d="M0.4,8.3 C0.1,8 0,7.5 0,6.9 L0,7 C0,7.6 0.2,8.1 0.5,8.4 L0.5,8.3 L0.4,8.3 Z"
                    opacity="0.12"></path>
            </g>
            <path
                d="M23,14.3 L18,17.1 L18.1,17.2 L23,14.4 C23.7,14 24,13.5 24,13 L24,13 C24,13.5 23.6,13.9 23,14.3 Z"
                fill="#000000"
                opacity="0.12"></path>
            <path
                d="M3.5,0.6 L23,11.7 C23.6,12.1 24,12.5 24,13 L24,13 C24,12.5 23.7,12 23,11.6 L3.5,0.5 C2.1,-0.3 1,0.4 1,2 L1,2.1 C1,0.5 2.1,-0.2 3.5,0.6 Z"
                fill="#FFFFFF"
                opacity="0.25"></path>
        </g>
    </svg>
)
